export default __webpack_public_path__ + "static/media/avatar-individual-male.4e5b917a.jpg";